export const getFormDataHeaders = () => {
	return {
		headers: {
			"Content-Type": "multipart/form-data"
		}
	};
};
